

















import { Component, Vue, Watch } from 'vue-property-decorator';
import { goTop } from '@/global/utils';
import { activityDetail } from '@/api/user/user';
@Component
export default class Activity extends Vue {
  get userInfo() {
    return this.$store.state.userInfo;
  }

  private data: object[] = [];


  private listColumns: object[] = [
  {
    title: "用户id",
    key: "uid",
    align: "center",
  },
  {
    title: "昵称",
    key: "nick_name",
    align: "center",
  },
];

  @Watch('$route')
  private routechange(to: any, from: any) {
    if (to.name == 'message') {
      this.getActivity();
    }
  }
  private created() {
    this.getActivity();
    goTop();
  }
  // 获取数据
  private async getActivity() {
    const res: any = await activityDetail();
    this.$nextTick(() => {
      this.data = res;
    });
  }

}
